module.exports = __webpack_public_path__ + "img/last-badge-prospect.6247b754.svg";